const rankingItems = [
  {
    rank: 1,
    title: '狂飙',
    desc: '张译张颂文演技巅峰对决',
    heat: '热度 9.8',
    tag: '国产剧',
    trend: '↑',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20Chinese%20crime%20drama%20poster%20style%2C%20intense%20mood%20with%20warm%20amber%20and%20shadow%20contrast%2C%20artistic%20film%20poster%20aesthetic%2C%20dramatic%20lighting%2C%20terracotta%20and%20gold%20tones%2C%20no%20text&width=300&height=400&seq=rank-01&orientation=portrait',
  },
  {
    rank: 2,
    title: '庆余年第二季',
    desc: '范闲归来京都风云再起',
    heat: '热度 9.7',
    tag: '古装剧',
    trend: '↑',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20drama%20poster%20style%20with%20flowing%20robes%20and%20palace%20architecture%2C%20warm%20golden%20and%20deep%20red%20color%20scheme%2C%20cinematic%20atmosphere%2C%20artistic%20illustration%2C%20no%20text&width=300&height=400&seq=rank-02&orientation=portrait',
  },
  {
    rank: 3,
    title: '长安十二时辰',
    desc: '唐朝悬疑巨制口碑炸裂',
    heat: '热度 9.5',
    tag: '古装剧',
    trend: '→',
    img: 'https://readdy.ai/api/search-image?query=Tang%20dynasty%20night%20scene%20with%20lanterns%20and%20ancient%20city%20walls%2C%20dramatic%20cinematic%20lighting%2C%20film%20poster%20aesthetic%2C%20warm%20amber%20and%20crimson%20tones%2C%20artistic%20illustration%2C%20no%20text&width=300&height=400&seq=rank-03&orientation=portrait',
  },
  {
    rank: 4,
    title: '繁花',
    desc: '王家卫风格上海故事',
    heat: '热度 9.4',
    tag: '都市剧',
    trend: '↑',
    img: 'https://readdy.ai/api/search-image?query=1990s%20Shanghai%20cityscape%20with%20neon%20lights%20and%20vintage%20atmosphere%2C%20warm%20golden%20and%20rose%20tones%2C%20cinematic%20film%20poster%20style%2C%20nostalgic%20mood%2C%20artistic%20illustration%2C%20no%20text&width=300&height=400&seq=rank-04&orientation=portrait',
  },
  {
    rank: 5,
    title: '莲花楼',
    desc: '成毅古装武侠探案力作',
    heat: '热度 9.3',
    tag: '武侠剧',
    trend: '↑',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20drama%20poster%20style%20with%20misty%20mountains%20and%20flowing%20silk%2C%20warm%20amber%20and%20jade%20green%20tones%2C%20cinematic%20atmosphere%2C%20artistic%20illustration%2C%20no%20text&width=300&height=400&seq=rank-05&orientation=portrait',
  },
  {
    rank: 6,
    title: '长相思',
    desc: '杨紫古装仙侠虐恋大剧',
    heat: '热度 9.2',
    tag: '仙侠剧',
    trend: '↓',
    img: 'https://readdy.ai/api/search-image?query=Ethereal%20Chinese%20fantasy%20drama%20poster%20style%20with%20floating%20clouds%20and%20starlight%2C%20warm%20golden%20and%20soft%20pink%20tones%2C%20cinematic%20fairy%20tale%20atmosphere%2C%20artistic%20illustration%2C%20no%20text&width=300&height=400&seq=rank-06&orientation=portrait',
  },
];

export default function SectionRanking() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-100" style={{ scrollMarginTop: '64px' }}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-3">
            热播榜单
          </span>
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-2">热播榜单 · 全网热度TOP6</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">根据全网热度实时更新，发现大家都在追的好剧</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
          {rankingItems.map((item) => (
            <article key={item.rank} className="group relative rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer">
              <div className="relative aspect-[3/4] overflow-hidden">
                <img src={item.img} alt={item.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute top-2 left-2 w-7 h-7 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center font-heading text-sm">
                  {item.rank}
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-3">
                  <h3 className="font-heading text-sm text-background-50 mb-1">{item.title}</h3>
                  <div className="flex items-center gap-2 text-xs text-background-200/80">
                    <span>{item.heat}</span>
                    <span>{item.trend}</span>
                  </div>
                </div>
              </div>
              <div className="p-3">
                <p className="text-xs text-foreground-500">{item.desc}</p>
                <span className="inline-block mt-2 px-2 py-0.5 rounded text-xs bg-secondary-100 text-secondary-700">{item.tag}</span>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}